"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirection = void 0;
var SortDirection;
(function (SortDirection) {
    SortDirection["Ascend"] = "ascend";
    SortDirection["Descend"] = "descend";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
